import React, { useState, useEffect } from 'react';
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import moment from "moment";
import PerformanceGraph from './PerformanceGraph';
import { axiosInstance } from "../../../interceptors/AxiosInterceptor";
import ListIcon from '@mui/icons-material/List';
import BarChartIcon from '@mui/icons-material/BarChart';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, CartesianGrid, Legend, LineChart, Line, } from 'recharts';
import { Tooltip as CharTooltip } from 'recharts';
import {
    Box,
    Grid,
    TextField,
    Typography,
    Tooltip,
    IconButton,
    Select,
    MenuItem,
    Card,
    Button,
    CircularProgress,
} from "@mui/material";
import { Margin } from '@mui/icons-material';
import ClassNameGenerator from '@mui/utils/ClassNameGenerator';

const PerfDashboard2 = (e) => {


    const [selectionKey, setSelectionKey] = useState('Capability'); // Default selection key
    const [selectedValue, setSelectedValue] = useState('ALL'); // Default to 'ALL' for all subcategories
    const [sortOrder, setSortOrder] = useState('desc'); // Default to descending sort order
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [perfData, setPerfData] = useState([]);
    const [loader, setLoader] = useState(false)
    const [capabilityData, setCapabilityData] = useState([])
    const [creativityData, setCreativityData] = useState([])
    const [collaborationData, setCollaborationData] = useState([])
    const [complianceData, setComplianceData] = useState([])
    const [customerFocusData, setCustomerFocusData] = useState([])



    function getUniqueProjectsWithScore(list) {
        const projectMap = new Map();
    
        for (const item of list) {
            const projectName = item.project;
            const score = item.finalUKSCORE || 0;
    
            if (!projectMap.has(projectName)) {
                projectMap.set(projectName, {
                    ...item,
                    totalScore: score,
                    count: 1,
                });
            } else {
                const existing = projectMap.get(projectName);
                existing.totalScore += score;
                existing.count += 1;
            }
        }
    
        const result = Array.from(projectMap.values()).map(item => ({
            ...item,
            projectScore: item.totalScore / item.count, // average score
        }));
    
        console.log(result.sort((a, b) => b.projectScore - a.projectScore), "llll");
        return result.sort((a, b) => b.projectScore - a.projectScore);
    }
    

    function getProjectManagerScores(list) {
        const result = {};

        list.forEach(item => {
            if (item.role === "Project Manager") {
                const id = item.associateId;

                if (!result[id]) {
                    result[id] = { ...item };
                    result[id].ProjectManagerScore = item.finalUKSCORE || 0;
                } else {
                    result[id].ProjectManagerScore += item.finalUKSCORE || 0;
                }
            }
        });

        return Object.values(result).sort((a, b) => b.ProjectManagerScore - a.ProjectManagerScore);
    }


    function accumulateScoresByLevel(data) {
        const map = {};

        data.forEach(item => {
            const level = item.level;
            const score = item.finalUKSCORE || 0;

            if (map[level]) {
                map[level] += score;
            } else {
                map[level] = score;
            }
        });

        // Convert the map to a list of objects and sort it
        return Object.entries(map).map(([level, finalUKSCORE]) => ({
            level,
            finalUKSCORE
        })).sort((a, b) => b.finalUKSCORE - a.finalUKSCORE);
    }





    const categories = [
        { title: "Capability", data: capabilityData },
        { title: "Creativity", data: creativityData },
        { title: "Collaboration", data: collaborationData },
        { title: "Compliance", data: complianceData },
        { title: "Customer Focus", data: customerFocusData },
    ];
    const categoriesTwo = [
        { title: "Capability", data: getUniqueProjectsWithScore(capabilityData) },
        { title: "Creativity", data: getUniqueProjectsWithScore(creativityData) },
        { title: "Collaboration", data: getUniqueProjectsWithScore(collaborationData) },
        { title: "Compliance", data: getUniqueProjectsWithScore(complianceData) },
        { title: "Customer Focus", data: getUniqueProjectsWithScore(customerFocusData) },
    ];
    const categoriesThree = [
        { title: "Capability", data: getProjectManagerScores(capabilityData) },
        { title: "Creativity", data: getProjectManagerScores(creativityData) },
        { title: "Collaboration", data: getProjectManagerScores(collaborationData) },
        { title: "Compliance", data: getProjectManagerScores(complianceData) },
        { title: "Customer Focus", data: getProjectManagerScores(customerFocusData) },
    ];
    const categoriesFour = [
        { title: "Capability", data: accumulateScoresByLevel(capabilityData) },
        { title: "Creativity", data: accumulateScoresByLevel(creativityData) },
        { title: "Collaboration", data: accumulateScoresByLevel(collaborationData) },
        { title: "Compliance", data: accumulateScoresByLevel(complianceData) },
        { title: "Customer Focus", data: accumulateScoresByLevel(customerFocusData) },
    ];

    const [viewModes, setViewModes] = useState(
        Array(categories.length).fill("list")
    );
    const [viewModesTwo, setViewModesTwo] = useState(
        Array(categoriesTwo.length).fill("list")
    );
    const [viewModesThree, setViewModesThree] = useState(
        Array(categoriesThree.length).fill("list")
    );
    const [viewModesFour, setViewModesFour] = useState(
        Array(categoriesFour.length).fill("list")
    );

    const toggleView = (index) => {
        const updatedViews = [...viewModes];
        updatedViews[index] = viewModes[index] === "list" ? "chart" : "list";
        setViewModes(updatedViews);
    };
    const toggleViewTwo = (index) => {
        const updatedViews = [...viewModesTwo];
        updatedViews[index] = viewModesTwo[index] === "list" ? "chart" : "list";
        setViewModesTwo(updatedViews);
    };
    const toggleViewThree = (index) => {
        const updatedViews = [...viewModesThree];
        updatedViews[index] = viewModesThree[index] === "list" ? "chart" : "list";
        setViewModesThree(updatedViews);
    };
    const toggleViewFour = (index) => {
        const updatedViews = [...viewModesFour];
        updatedViews[index] = viewModesFour[index] === "list" ? "chart" : "list";
        setViewModesFour(updatedViews);
    };




    const data = {
        Capability: [
            "Execution efficiency",
            "Quality of output",
            "Accountability and Ownership",
        ],
        Creativity: [
            "Originality",
            "Alignment",
            "Complexity and Effort"
        ],
        Collaboration: [
            "Team Contribution",
            "Adaptability and Flexibility",
            "Relationship Building"
        ],
        Compliance: [
            "Awareness",
            "Adherence",
            "Accuracy and Integrity of records"
        ],
        CustomerFocus: [
            "Convenience",
            "Value Creation",
            "Cost optimization",
            "Brand promotion"
        ]
    };


    const getBiweeklyRange = (date = new Date()) => {
        const year = date.getFullYear();
        const month = date.getMonth();
        const day = date.getDate();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        let start, end;
        if (day <= 15) {
            start = new Date(year, month, 1);
            end = new Date(year, month, 15);
        } else {
            start = new Date(year, month, 16);
            end = new Date(year, month, daysInMonth);
        }

        return {
            start: start.toISOString().split("T")[0], // Format as YYYY-MM-DD
            end: end.toISOString().split("T")[0],
        };
    };
    useEffect(() => {
        const { start, end } = getBiweeklyRange();
        setStartDate(start);
        setEndDate(end);
    }, []);




    // Handle biweekly navigation
    const handleStartDateChange = (e, type) => {
        if (type === "icon") {
            const newStartDate =
                moment(startDate).format("DD").toString() === "01"
                    ? moment(startDate)
                        .subtract(1, "month")
                        .startOf("month")
                        .add(15, "days")
                        .format("YYYY-MM-DD")
                    : moment(startDate).startOf("month").format("YYYY-MM-DD");
            const newEndDate =
                moment(startDate).format("DD").toString() === "01"
                    ? moment(startDate)
                        .subtract(1, "month")
                        .endOf("month")
                        .format("YYYY-MM-DD")
                    : moment(startDate)
                        .startOf("month")
                        .add(14, "day")
                        .format("YYYY-MM-DD");
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        } else if (type === "icon") {
            const newStartDate = moment(startDate)
                .subtract(1, "month")
                .startOf("month")
                .format("YYYY-MM-DD");
            const newEndDate = moment(endDate)
                .subtract(1, "month")
                .endOf("month")
                .format("YYYY-MM-DD");
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        } else {
            const value = e.target.value;
            setStartDate(value);
            // setEndDateError("");
            if (value && endDate && value > endDate) {
                // setStartDateError("Start date cannot be after end date");
            } else {
                // setStartDateError("");
            }
        }
    };

    const handleEndDateChange = (e, type) => {
        if (type === "icon") {
            const newStartDate =
                moment(startDate).format("DD").toString() === "01"
                    ? moment(startDate).add(15, "days").format("YYYY-MM-DD")
                    : moment(startDate)
                        .add(1, "month")
                        .startOf("month")
                        .format("YYYY-MM-DD");
            const newEndDate =
                moment(startDate).format("DD").toString() === "01"
                    ? moment(startDate).endOf("month").format("YYYY-MM-DD")
                    : moment(startDate)
                        .add(1, "month")
                        .startOf("month")
                        .add(14, "days")
                        .format("YYYY-MM-DD");
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        } else if (type === "icon") {
            const newStartDate = moment(startDate)
                .add(1, "month")
                .startOf("month")
                .format("YYYY-MM-DD");
            const newEndDate = moment(endDate)
                .add(1, "month")
                .endOf("month")
                .format("YYYY-MM-DD");
            setStartDate(newStartDate);
            setEndDate(newEndDate);
        } else {
            const value = e.target.value;
            setEndDate(value);
            // setStartDateError("");
            if (value && startDate && value < startDate) {
                // setEndDateError("End date cannot be before start date");
            } else {
                // setEndDateError("");
            }
        }
    };


    const handleKeyChange = (event) => {
        setLoader(true)
        const selectedKey = event.target.value;
        setSelectionKey(selectedKey);
        setSelectedValue('ALL');
        setLoader(false)
    };

    const handleValueChange = (event) => {
        setLoader(true)
        const value = event.target.value;
        setSelectedValue(value);
        setLoader(false)
    };

    function parseRatings(data) {
        return data.map(item => ({
            ...item,
            ratingsObj: JSON.parse(item.ratingsObj)
        }));
    }

    function addUKKey(data) {
        return data.map((item, rowIndex) => {
            let factor = 0.3;


            if (rowIndex === 0) {
                const subIndexFactors = { 0: 0.3, 1: 0.3, 2: 0.4 };
                factor = subIndexFactors[item.subIndex] || 0.3;
            } else if (rowIndex === 1) {
                const subIndexFactors = { 0: 0.2, 1: 0.6, 2: 0.2 };
                factor = subIndexFactors[item.subIndex] || 0.3;
            } else if (rowIndex === 2) {
                const subIndexFactors = { 0: 0.4, 1: 0.2, 2: 0.4 };
                factor = subIndexFactors[item.subIndex] || 0.3;
            } else if (rowIndex === 3) {
                const subIndexFactors = { 0: 0.3, 1: 0.3, 2: 0.4 };
                factor = subIndexFactors[item.subIndex] || 0.3;
            } else if (rowIndex === 4) {
                const subIndexFactors = { 0: 0.3, 1: 0.2, 2: 0.1, 3: 0.4 };
                factor = subIndexFactors[item.subIndex] || 0.3;
            }


            return {
                ...item,
                UK: (item.rating * factor * 180) / 5
            };
        });
    }


    // const generateData = () => {
    //     setLoader(true)
    //     if (perfData.length !== 0) {
    //         let mainData = perfData.map((item) => {
    //             return {
    //                 ...item,
    //                 ratingsObj: addUKKey(item.ratingsObj)
    //             };
    //         });
    //         UkscoreData(mainData)
    //     } else {
    //         console.log("empty")
    //         setLoader(false)
    //     }
    // }

    const generateData = () => {
        setLoader(true);
        if (perfData.length !== 0) {
            let mainData = perfData
                .filter(item => item.projectManagerSubmission === true)
                .map((item) => {
                    return {
                        ...item,
                        ratingsObj: addUKKey(item.ratingsObj)
                    };
                });

            if (mainData.length > 0) {

                UkscoreData(mainData);
            } else {
                console.log("No data with project manager submission");
            }
        } else {
            console.log("empty");
            setLoader(false);
        }
    };




    const UkscoreData = (data) => {

        const updatedData = data.map((x) => {
            let finalUKSCORE = 0;

            if (selectionKey === "Capability" && selectedValue === "ALL") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Capability" && selectedValue === "Execution efficiency") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 0 && item.subIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Capability" && selectedValue === "Quality of output") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 0 && item.subIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Capability" && selectedValue === "Accountability and Ownership") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 0 && item.subIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Creativity" && selectedValue === "ALL") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Creativity" && selectedValue === "Originality") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 1 && item.subIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Creativity" && selectedValue === "Alignment") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 1 && item.subIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Creativity" && selectedValue === "Complexity and Effort") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 1 && item.subIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Collaboration" && selectedValue === "ALL") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Collaboration" && selectedValue === "Team Contribution") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 2 && item.subIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Collaboration" && selectedValue === "Adaptability and Flexibility") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 2 && item.subIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Collaboration" && selectedValue === "Relationship Building") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 2 && item.subIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Compliance" && selectedValue === "ALL") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 3) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Compliance" && selectedValue === "Awareness") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 3 && item.subIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Compliance" && selectedValue === "Adherence") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 3 && item.subIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "Compliance" && selectedValue === "Accuracy and Integrity of records") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 3 && item.subIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "CustomerFocus" && selectedValue === "ALL") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 4) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "CustomerFocus" && selectedValue === "Convenience") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 4 && item.subIndex === 0) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "CustomerFocus" && selectedValue === "Value Creation") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 4 && item.subIndex === 1) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "CustomerFocus" && selectedValue === "Cost optimization") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 4 && item.subIndex === 2) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            if (selectionKey === "CustomerFocus" && selectedValue === "Brand promotion") {
                x.ratingsObj.forEach((item) => {
                    if (item.rowIndex === 4 && item.subIndex === 3) {
                        finalUKSCORE += item.UK;
                    }
                });
            }
            return { ...x, finalUKSCORE };
        });


        return finalDataToDisplay(updatedData);
    };


    function processNestedLists(nestedLists, selectionKey, selectedValue) {
        return nestedLists.map((list) => {
            let finalUKSCORE = 0;
            let date = list[0]?.rateStartTime?.split(" ")[0] || null; // Extract only the date part

            list.forEach((item) => {
                if (
                    (selectionKey === "Capability" && selectedValue === "ALL" && item.rowIndex === 0) ||
                    (selectionKey === "Capability" && selectedValue === "Execution efficiency" && item.rowIndex === 0 && item.subIndex === 0) ||
                    (selectionKey === "Capability" && selectedValue === "Quality of output" && item.rowIndex === 0 && item.subIndex === 1) ||
                    (selectionKey === "Capability" && selectedValue === "Accountability and Ownership" && item.rowIndex === 0 && item.subIndex === 2) ||
                    (selectionKey === "Creativity" && selectedValue === "ALL" && item.rowIndex === 1) ||
                    (selectionKey === "Creativity" && selectedValue === "Originality" && item.rowIndex === 1 && item.subIndex === 0) ||
                    (selectionKey === "Creativity" && selectedValue === "Alignment" && item.rowIndex === 1 && item.subIndex === 1) ||
                    (selectionKey === "Creativity" && selectedValue === "Complexity and Effort" && item.rowIndex === 1 && item.subIndex === 2) ||
                    (selectionKey === "Collaboration" && selectedValue === "ALL" && item.rowIndex === 2) ||
                    (selectionKey === "Collaboration" && selectedValue === "Team Contribution" && item.rowIndex === 2 && item.subIndex === 0) ||
                    (selectionKey === "Collaboration" && selectedValue === "Adaptability and Flexibility" && item.rowIndex === 2 && item.subIndex === 1) ||
                    (selectionKey === "Collaboration" && selectedValue === "Relationship Building" && item.rowIndex === 2 && item.subIndex === 2) ||
                    (selectionKey === "Compliance" && selectedValue === "ALL" && item.rowIndex === 3) ||
                    (selectionKey === "Compliance" && selectedValue === "Awareness" && item.rowIndex === 3 && item.subIndex === 0) ||
                    (selectionKey === "Compliance" && selectedValue === "Adherence" && item.rowIndex === 3 && item.subIndex === 1) ||
                    (selectionKey === "Compliance" && selectedValue === "Accuracy and Integrity of records" && item.rowIndex === 3 && item.subIndex === 2) ||
                    (selectionKey === "CustomerFocus" && selectedValue === "ALL" && item.rowIndex === 4) ||
                    (selectionKey === "CustomerFocus" && selectedValue === "Convenience" && item.rowIndex === 4 && item.subIndex === 0) ||
                    (selectionKey === "CustomerFocus" && selectedValue === "Value Creation" && item.rowIndex === 4 && item.subIndex === 1) ||
                    (selectionKey === "CustomerFocus" && selectedValue === "Cost optimization" && item.rowIndex === 4 && item.subIndex === 2) ||
                    (selectionKey === "CustomerFocus" && selectedValue === "Brand promotion" && item.rowIndex === 4 && item.subIndex === 3)
                ) {
                    finalUKSCORE += item.UK || 0;
                }
            });

            return { finalUKSCORE: Math.floor(finalUKSCORE), date };
        }).sort((a, b) => new Date(a.date) - new Date(b.date));
    }



    const finalDataToDisplay = (data) => {



        const processedData = data
            .map(obj => ({ ...obj, finalUKSCORE: Math.round(obj.finalUKSCORE) }))
            .sort((a, b) => b.finalUKSCORE - a.finalUKSCORE);
        const parsedData = processedData.map(obj => ({
            ...obj,
            lastSixRatings: processNestedLists(
                obj.lastSixRatings.map(rating => addUKKey(JSON.parse(rating))),
                selectionKey,
                selectedValue
            )
        }));

        switch (selectionKey) {
            case "Capability":
                setCapabilityData(parsedData);
                console.log(parsedData);
                setSelectionKey("Creativity");
                setSelectedValue("ALL");
                break;
            case "Creativity":
                setCreativityData(parsedData);
                console.log(parsedData);
                setSelectionKey("Collaboration");
                setSelectedValue("ALL");
                break;
            case "Collaboration":
                setCollaborationData(parsedData);
                console.log(parsedData);
                setSelectionKey("Compliance");
                setSelectedValue("ALL");
                break;
            case "Compliance":
                setComplianceData(parsedData);
                console.log(parsedData);
                setSelectionKey("CustomerFocus");
                setSelectedValue("ALL");
                break;
            case "CustomerFocus":
                setCustomerFocusData(parsedData);
                break;
            default:
                break;
        }
        setLoader(false)
    };



    useEffect(() => {
        if (perfData) {
            generateData();
        }
    }, [perfData]);

    const fetchRatings = async () => {
        setSelectionKey("Capability")
        setSelectedValue("ALL")
        try {
            setLoader(true);
            const res = await axiosInstance.put(`/user/getAllAssociateRatings?startDate=${startDate}&endDate=${endDate}`);
            const result = parseRatings(res.data);
            setPerfData(result);
        } catch (err) {
            console.error("API Error:", err);
        } finally {
            setLoader(false);
        }
    };



    useEffect(() => {
        if (startDate && endDate) {
            fetchRatings();
        }
    }, [startDate, endDate]);


    useEffect(() => {
        setLoader(true);
        generateData()
        setLoader(false);
    }, [selectionKey, selectedValue])


    return (
        <Card >
            <div style={{ margin: "20px", marginBottom: "0px" }}>
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                    {/* <div>
                        <Typography style={{
                            display: "inline-block",
                            marginRight: "5px"
                        }}>Category: </Typography>
                        <Select
                            labelId="category-select-label"
                            id="category-select"
                            value={selectionKey}
                            onChange={handleKeyChange}
                            style={{ font: "small-caption", fontFamily: "Lucida Grande", height: "35px" }}
                        >
                            {Object.keys(data).map((key) => (
                                <MenuItem key={key} value={key} style={{ font: "small-caption" }}>
                                    {key}
                                </MenuItem>
                            ))}
                        </Select>
                    </div> */}

                    {/* <div>
                        <Typography style={{
                            display: "inline-block",
                            marginRight: "5px"
                        }}>Parameters: </Typography>
                        <Select
                            id="value-select"
                            value={selectedValue}
                            onChange={handleValueChange}
                            style={{ font: "small-caption", fontFamily: "Lucida Grande", height: "35px" }}

                        >
                            <MenuItem value="ALL" style={{ font: "small-caption" }}>ALL</MenuItem>
                            {data[selectionKey]?.map((value, index) => (
                                <MenuItem key={index} value={value} style={{ font: "small-caption" }}>
                                    {value}
                                </MenuItem>
                            ))}
                        </Select>
                    </div> */}

                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Tooltip title="Click">
                            <IconButton onClick={(e) => handleStartDateChange(e, "icon")}>
                                <ArrowBackIosIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>

                        <TextField
                            type="date"
                            value={startDate}
                            label="Start Date"
                            size="small"
                            onChange={handleStartDateChange}
                            InputLabelProps={{
                                style: { font: "small-caption", fontFamily: "Lucida Grande" },
                                shrink: true,
                            }}
                            InputProps={{
                                style: { font: "small-caption", fontFamily: "Lucida Grande" },
                            }}
                        />

                        <TextField
                            type="date"
                            label="End Date"
                            size="small"
                            value={endDate}
                            onChange={handleEndDateChange}
                            InputLabelProps={{
                                style: { font: "small-caption", fontFamily: "Lucida Grande" },
                                shrink: true,
                            }}
                            InputProps={{
                                style: { font: "small-caption", fontFamily: "Lucida Grande" },
                            }}
                        />

                        <Tooltip title="Click">
                            <IconButton onClick={(e) => handleEndDateChange(e, "icon")}>
                                <ArrowForwardIosIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </div>



            {loader ? (
                <Grid sx={{ textAlign: "center" }} item xs={12}>
                    <Box style={{ paddingTop: "50px", paddingBottom: "40px" }}>
                        <CircularProgress />
                    </Box>
                </Grid>
            ) : (
                <>
                    <div style={{ padding: "20px" }}>
                        <Typography variant="h5" style={{ marginBottom: "24px", fontWeight: 700 }}>
                            Top 5 Performers Based on UK SCORE (Category-Wise)
                        </Typography>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {categories.map((category, catIndex) => (
                                <div
                                    key={catIndex}
                                    style={{
                                        flex: "1 1 300px",
                                        maxWidth: "1500px",
                                        border: "1px solid #ccc",
                                        borderRadius: "12px",
                                        padding: "16px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                        backgroundColor: "#fafafa",
                                        position: "relative",
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                            {category.title}
                                        </Typography>
                                        <button
                                            onClick={() => toggleView(catIndex)}
                                            style={{
                                                minWidth: "auto",
                                                padding: 4,
                                                cursor: "pointer",
                                                backgroundColor: "#f0f0f0",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 4,
                                            }}
                                        >
                                            {viewModes[catIndex] === "list" ? (
                                                <BarChartIcon fontSize="small" />
                                            ) : (
                                                <ListIcon fontSize="small" />
                                            )}
                                        </button>
                                    </div>

                                    {category.data.length === 0 ? (
                                        <Typography variant="body2" style={{ fontStyle: "italic", color: "#999" }}>
                                            No data available
                                        </Typography>
                                    ) : viewModes[catIndex] === "list" ? (
                                        category.data.slice(0, 5).map((x, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "6px 0",
                                                    borderBottom: "1px solid #eee",
                                                }}
                                            >
                                                <Typography style={{ fontWeight: 500 }}>
                                                    {`${index + 1}. ${x.fullname}`}
                                                </Typography>
                                                <Typography style={{ color: "#1976d2" }}>
                                                    Score: {x.finalUKSCORE}
                                                </Typography>
                                            </div>
                                        ))
                                    ) : (
                                        <ResponsiveContainer width="100%" height={300}>
                                            <LineChart margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis
                                                    dataKey="date"
                                                    type="category"
                                                    allowDuplicatedCategory={false}
                                                    tick={{ fontSize: 10 }}
                                                />
                                                <YAxis />
                                                <CharTooltip />
                                                <Legend />
                                                {category.data.slice(0, 5).map((user, idx) => (
                                                    <Line
                                                        key={user.fullname}
                                                        type="monotone"
                                                        data={user.lastSixRatings.map((r, i) => ({
                                                            date: r.date,
                                                            score: r.finalUKSCORE,
                                                        }))}
                                                        dataKey="score"
                                                        name={user.fullname}
                                                        stroke={["#1976d2", "#2e7d32", "#d32f2f", "#f9a825", "#6a1b9a"][idx % 5]}
                                                        strokeWidth={2}
                                                        dot={{ r: 2 }}
                                                    />
                                                ))}
                                            </LineChart>
                                        </ResponsiveContainer>
                                    )}
                                </div>
                            ))}
                        </div>

                        <hr style={{ marginTop: "40px", borderTop: "1px solid #ccc" }} />
                    </div>
                    <div style={{ padding: "20px" }}>
                        <Typography variant="h5" style={{ marginBottom: "24px", fontWeight: 700 }}>
                            Top 5 Projects Based on UK SCORE (Category-Wise)
                        </Typography>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {categoriesTwo.map((category, catIndex) => (
                                <div
                                    key={catIndex}
                                    style={{
                                        flex: "1 1 300px",
                                        maxWidth: "1500px",
                                        border: "1px solid #ccc",
                                        borderRadius: "12px",
                                        padding: "16px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                        backgroundColor: "#fafafa",
                                        position: "relative",
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                            {category.title}
                                        </Typography>
                                        <button
                                            onClick={() => toggleViewTwo(catIndex)}
                                            style={{
                                                minWidth: "auto",
                                                padding: 4,
                                                cursor: "pointer",
                                                backgroundColor: "#f0f0f0",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 4,
                                            }}
                                        >
                                            {viewModesTwo[catIndex] === "list" ? (
                                                <BarChartIcon fontSize="small" />
                                            ) : (
                                                <ListIcon fontSize="small" />
                                            )}
                                        </button>
                                    </div>

                                    {category.data.length === 0 ? (
                                        <Typography variant="body2" style={{ fontStyle: "italic", color: "#999" }}>
                                            No data available
                                        </Typography>
                                    ) : viewModesTwo[catIndex] === "list" ? (
                                        category.data.slice(0, 5).map((x, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "6px 0",
                                                    borderBottom: "1px solid #eee",
                                                }}
                                            >
                                                <Typography style={{ fontWeight: 500 }}>
                                                    {`${index + 1}. ${x.project}`}
                                                </Typography>
                                                <Typography style={{ color: "#1976d2" }}>
                                                    Score: {x.projectScore}
                                                </Typography>
                                            </div>
                                        ))
                                    ) : (
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart
                                                data={category.data.slice(0, 5)}
                                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="project" tick={{ fontSize: 12 }} />
                                                <YAxis />
                                                <CharTooltip />
                                                <Legend />
                                                <Bar
                                                    dataKey="projectScore"
                                                    name="UK SCORE"
                                                    fill="#1976d2"
                                                    barSize={40}
                                                />
                                            </BarChart>
                                        </ResponsiveContainer>


                                    )}
                                </div>
                            ))}
                        </div>
                        <hr style={{ marginTop: "40px", borderTop: "1px solid #ccc" }} />
                    </div>
                    <div style={{ padding: "20px" }}>
                        <Typography variant="h5" style={{ marginBottom: "24px", fontWeight: 700 }}>
                            Top 5 Project Managers Based on UK SCORE (Category-Wise)
                        </Typography>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {categoriesThree.map((category, catIndex) => (
                                <div
                                    key={catIndex}
                                    style={{
                                        flex: "1 1 300px",
                                        maxWidth: "1500px",
                                        border: "1px solid #ccc",
                                        borderRadius: "12px",
                                        padding: "16px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                        backgroundColor: "#fafafa",
                                        position: "relative",
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                            {category.title}
                                        </Typography>
                                        <button
                                            onClick={() => toggleViewThree(catIndex)}
                                            style={{
                                                minWidth: "auto",
                                                padding: 4,
                                                cursor: "pointer",
                                                backgroundColor: "#f0f0f0",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 4,
                                            }}
                                        >
                                            {viewModesThree[catIndex] === "list" ? (
                                                <BarChartIcon fontSize="small" />
                                            ) : (
                                                <ListIcon fontSize="small" />
                                            )}
                                        </button>
                                    </div>

                                    {category.data.length === 0 ? (
                                        <Typography variant="body2" style={{ fontStyle: "italic", color: "#999" }}>
                                            No data available
                                        </Typography>
                                    ) : viewModesThree[catIndex] === "list" ? (
                                        category.data.slice(0, 5).map((x, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "6px 0",
                                                    borderBottom: "1px solid #eee",
                                                }}
                                            >
                                                <Typography style={{ fontWeight: 500 }}>
                                                    {`${index + 1}. ${x.fullname}`}
                                                </Typography>
                                                <Typography style={{ color: "#1976d2" }}>
                                                    Score: {x.finalUKSCORE}
                                                </Typography>
                                            </div>
                                        ))
                                    ) : (
                                        <ResponsiveContainer width="100%" height={300}>
                                            <LineChart margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis
                                                    dataKey="date"
                                                    type="category"
                                                    allowDuplicatedCategory={false}
                                                    tick={{ fontSize: 10 }}
                                                />
                                                <YAxis />
                                                <CharTooltip />
                                                <Legend />
                                                {category.data.slice(0, 5).map((user, idx) => (
                                                    <Line
                                                        key={user.fullname}
                                                        type="monotone"
                                                        data={user.lastSixRatings.map((r, i) => ({
                                                            date: r.date,
                                                            score: r.finalUKSCORE,
                                                        }))}
                                                        dataKey="score"
                                                        name={user.fullname}
                                                        stroke={["#1976d2", "#2e7d32", "#d32f2f", "#f9a825", "#6a1b9a"][idx % 5]}
                                                        strokeWidth={2}
                                                        dot={{ r: 2 }}
                                                    />
                                                ))}
                                            </LineChart>
                                        </ResponsiveContainer>


                                    )}
                                </div>
                            ))}
                        </div>
                        <hr style={{ marginTop: "40px", borderTop: "1px solid #ccc" }} />
                    </div>
                    <div style={{ padding: "20px" }}>
                        <Typography variant="h5" style={{ marginBottom: "24px", fontWeight: 700 }}>
                            Top 5 Organization Levels Based on UK SCORE (Category-Wise)
                        </Typography>

                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {categoriesFour.map((category, catIndex) => (
                                <div
                                    key={catIndex}
                                    style={{
                                        flex: "1 1 300px",
                                        maxWidth: "1500px",
                                        border: "1px solid #ccc",
                                        borderRadius: "12px",
                                        padding: "16px",
                                        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                        backgroundColor: "#fafafa",
                                        position: "relative",
                                    }}
                                >
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "12px" }}>
                                        <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                            {category.title}
                                        </Typography>
                                        <button
                                            onClick={() => toggleViewFour(catIndex)}
                                            style={{
                                                minWidth: "auto",
                                                padding: 4,
                                                cursor: "pointer",
                                                backgroundColor: "#f0f0f0",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: 4,
                                            }}
                                        >
                                            {viewModesFour[catIndex] === "list" ? (
                                                <BarChartIcon fontSize="small" />
                                            ) : (
                                                <ListIcon fontSize="small" />
                                            )}
                                        </button>
                                    </div>

                                    {category.data.length === 0 ? (
                                        <Typography variant="body2" style={{ fontStyle: "italic", color: "#999" }}>
                                            No data available
                                        </Typography>
                                    ) : viewModesFour[catIndex] === "list" ? (
                                        category.data.slice(0, 5).map((x, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    padding: "6px 0",
                                                    borderBottom: "1px solid #eee",
                                                }}
                                            >
                                                <Typography style={{ fontWeight: 500 }}>
                                                    {`${index + 1}. ${x.level}`}
                                                </Typography>
                                                <Typography style={{ color: "#1976d2" }}>
                                                    Score: {x.finalUKSCORE}
                                                </Typography>
                                            </div>
                                        ))
                                    ) : (
                                        <ResponsiveContainer width="100%" height={300}>
                                            <BarChart
                                                data={category.data.slice(0, 5)}
                                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="level" tick={{ fontSize: 12 }} />
                                                <YAxis />
                                                <CharTooltip />
                                                <Legend />
                                                <Bar
                                                    dataKey="finalUKSCORE"
                                                    name="UK SCORE"
                                                    fill="#1976d2"
                                                    barSize={40}
                                                />
                                            </BarChart>
                                        </ResponsiveContainer>

                                    )}
                                </div>
                            ))}
                        </div>
                        <hr style={{ marginTop: "40px", borderTop: "1px solid #ccc" }} />
                    </div>
                </>
            )}
        </Card>
    );
};

export default PerfDashboard2;